import * as React from 'react';
import { AppRegistry } from 'react-native';
import { Provider as PaperProvider } from 'react-native-paper';
import * as appJson from './app.json';
import App from './src/App';
import { QueryProvider } from './src/components/QueryProvider';

export default function Main() {
  return (
    <PaperProvider theme={{ dark: false }}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </PaperProvider>
  );
}

AppRegistry.registerComponent(appJson.expo.name, () => Main);